import { useLocation, Link, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface CreatedState {
    giftId: string;
    shareUrl: string;
    deleteUrl: string;
    deleteToken: string;
    title: string;
}

export default function Created() {
    const location = useLocation();
    const state = location.state as CreatedState | null;
    const [copied, setCopied] = useState(false);

    if (!state) {
        return <Navigate to="/create" replace />;
    }

    const copyLink = () => {
        navigator.clipboard.writeText(state.shareUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="page">
            <Header />
            <div className="success-container fade-in">
                <div className="success-icon">🎉</div>
                <h1>Lista utworzona!</h1>
                <p className="text-muted mt-md">
                    Twoja lista prezentów &ldquo;{state.title}&rdquo; została pomyślnie utworzona.
                    Skopiuj link poniżej i wyślij go znajomemu!
                </p>

                <div className="share-url-box mt-lg">
                    <input
                        className="form-input"
                        type="text"
                        value={state.shareUrl}
                        readOnly
                        onClick={(e) => (e.target as HTMLInputElement).select()}
                    />
                    <button className="btn btn-primary" onClick={copyLink}>
                        {copied ? '✓ Skopiowano!' : '📋 Kopiuj'}
                    </button>
                </div>

                <div className="glass mt-lg" style={{ padding: '24px', textAlign: 'left' }}>
                    <h3 style={{ marginBottom: '12px' }}>⚠️ Ważne informacje</h3>
                    <ul style={{ listStyle: 'disc', paddingLeft: '20px', color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        <li>
                            <strong>Link do udostępnienia:</strong>{' '}
                            <a href={state.shareUrl} target="_blank" rel="noopener noreferrer">
                                {state.shareUrl}
                            </a>
                        </li>
                        <li>
                            <strong>Token do usunięcia:</strong>{' '}
                            <code style={{ background: 'rgba(255,255,255,0.05)', padding: '2px 6px', borderRadius: '4px', fontSize: '0.8rem' }}>
                                {state.deleteToken}
                            </code>
                        </li>
                        <li style={{ color: 'var(--color-warning)' }}>
                            Zapisz token usunięcia — to jedyny sposób na usunięcie listy!
                        </li>
                    </ul>
                </div>

                <div className="mt-xl" style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link to="/create" className="btn btn-secondary">
                        + Stwórz kolejną
                    </Link>
                    <Link to="/" className="btn btn-ghost">
                        Strona główna
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
